// extracted by mini-css-extract-plugin
export var button = "_as-0";
export var icon = "_as-1";